import { useQuery, useQueryClient } from '@tanstack/react-query';

import { useEffect } from 'react';
import { fetchProjectFiles as fetchProjectFilesAPI } from '@/api/v4/project-files.api';
import { QueryKey } from '@/config/query-client';
import { PERMISSION } from '@/user/permissions/permission.type';
import { useUserPermissions } from '@/user/permissions/use-user-permissions';

import { projectIdState } from '../../project.state';
import { useAtomValue } from 'jotai';

export const useProjectFiles = () => {
  const queryClient = useQueryClient();
  const projectId = useAtomValue(projectIdState);

  const { hasRequiredPermission } = useUserPermissions();

  const fetchProjectFiles = async () => {
    if (!projectId) return [];

    return fetchProjectFilesAPI(projectId);
  };

  const query = useQuery({
    queryKey: [QueryKey.ProjectFiles, projectId],
    queryFn: fetchProjectFiles,
    enabled: !!projectId && hasRequiredPermission(PERMISSION.VIEW_FILES),
    staleTime: 1000 * 60 * 5,
  });

  useEffect(() => {
    if (query.data) {
      void queryClient.invalidateQueries({
        queryKey: [QueryKey.ProjectActionsInfo, projectId],
      });
    }
  }, [query.data, queryClient, projectId]);

  return query;
};
